/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { CONSTANT } from "../../../constants/constant";
import DeleteDialog from "../modal/dialog-delete/dialog-delete.view";
import { qualifyAction } from "../../../redux/store/admin/qualify/qualify.action";
import {
  HiddenLoading,
  ShowLoading,
} from "../../../redux/store/loading/loading.store";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../utils/configuration";
import { ApiUrl } from "../../../api/api-url";
import Service from "../../../api/api-service";
import { lookupDistrictAction } from "../../../redux/store/admin/lookup-district/lookup-district.action";
import { lookupProvinceAction } from "../../../redux/store/admin/lookup-province/lookup-province.action";
import QualifyModal from "../modal/qualify-modal/qualify-modal";

import "./qualify.scss";

const service = new Service();
const pagination = paginationFactory({
  sizePerPage: 10,
  paginationSize: 5,
  alwaysShowAllBtns: true,
  hideSizePerPage: true,
});
let dataInput = {};

class Qualify extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      qualifyModalShow: false,
      isOpenDelModal: false,
      rowId: null,
    };
    this.handleDelete = this.handleDelete.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.getDetailQualify = this.getDetailQualify.bind(this);
  }
  componentDidMount() {
    this.props.getLookupProvince();
    this.props.getLookupDistrict();
    this.props.getQualify();
  }
  getDetailQualify() {
    this.props.ShowLoading();
    service
      .get(ApiUrl.QualifyGetDetail + this.state.id)
      .then((response) => {
        this.props.HiddenLoading();
        if (response.content && response.content) {
          dataInput["other-data"] = response.content.id;
          this.setState({ qualifyModalShow: true });
        }
      })
      .catch((error) => {
        this.props.HiddenLoading();
        if (error && error.errorMessage) {
          ShowNotification(error.errorMessage, NotificationMessageType.Error);
        } else {
          ShowNotification(
            CONSTANT.message.error_unknown,
            NotificationMessageType.Error
          );
        }
      });
  }
  handleDelete() {
    this.props.deleteQualify({ Id: this.state.rowId });
  }
  handleShowModal() {
    dataInput["type"] = false;
    this.setState({ qualifyModalShow: true });
  }
  handleCloseModal(type, data) {
    switch (type) {
      case "close":
        this.setState({ qualifyModalShow: false });
        break;
      case "save":
        if (data.type) {
          this.props.updQualify({
            qualifyCode: data.qualifyCode,
            qualifyDate: data.qualifyDate,
            expiredDate: data.expiredDate,
            companyName: data.companyName,
            shortName: data.shortName,
            taxCode: data.taxCode,
            issuedDate: data.issuedDate,
            issuedBy: data.issuedBy,
            provinceId: data.provinceId,
            districtId: data.districtId,
            headquarters: data.headquarters,
            office: data.office,
            representer: data.representer,
            roleName: data.roleName,
            isActive: data.status,
            id: this.state.id,
          });
          this.setState({ qualifyModalShow: false });
        } else {
          this.props.createQualify({
            qualifyCode: data.qualifyCode,
            qualifyDate: data.qualifyDate,
            expiredDate: data.expiredDate,
            companyName: data.companyName,
            shortName: data.shortName,
            taxCode: data.taxCode,
            issuedDate: data.issuedDate,
            issuedBy: data.issuedBy,
            provinceId: data.provinceId,
            districtId: data.districtId,
            headquarters: data.headquarters,
            office: data.office,
            representer: data.representer,
            roleName: data.roleName,
          });
          this.setState({ qualifyModalShow: false });
        }
        break;
      default:
        break;
    }
  }
  render() {
    const columns = [
      {
        dataField: "companyName",
        text: "Tên Công Ty",
      },
      {
        dataField: "provinceName",
        text: "Tỉnh/ Thành",
        headerStyle: () => {
          return { width: "20%" };
        },
      },
      {
        dataField: "districtName",
        text: "Quận/ Huyện",
        headerStyle: () => {
          return { width: "20%" };
        },
      },
      {
        dataField: "isActive",
        text: "Trạng Thái",
        formatter: (cell) => {
          return cell ? CONSTANT.label.active : CONSTANT.label.deactive;
        },
        headerStyle: () => {
          return { width: "12%" };
        },
      },
      {
        dataField: "id",
        text: "Xóa",
        headerStyle: (colum, colIndex) => {
          return { width: "45px", textAlign: "center" };
        },
        formatter: (cellContent, row) => {
          return (
            <a
              onClick={(e) => {
                e.stopPropagation();
                this.setState({
                  ...this.state,
                  isOpenDelModal: true,
                  rowId: row.id,
                });
              }}
            >
              <svg
                width="18"
                height="18"
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="trash-alt"
                class="svg-inline--fa fa-trash-alt fa-w-14"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
              >
                <path
                  fill="red"
                  d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                ></path>
              </svg>
            </a>
          );
        },
      },
    ];
    const rowEvents = {
      onClick: (e, row, rowIndex) => {
        dataInput["districtId"] = row.districtId;
        dataInput["provinceId"] = row.provinceId;
        dataInput["qualifyCode"] = row.qualifyCode;
        dataInput["qualifyDate"] = row.qualifyDate;
        dataInput["expiredDate"] = row.expiredDate;
        dataInput["companyName"] = row.companyName;
        dataInput["shortName"] = row.shortName;
        dataInput["taxCode"] = row.taxCode;
        dataInput["issuedDate"] = row.issuedDate;
        dataInput["issuedBy"] = row.issuedBy;
        dataInput["headquarters"] = row.headquarters;
        dataInput["office"] = row.office;
        dataInput["representer"] = row.representer;
        dataInput["roleName"] = row.roleName;
        dataInput["status"] = row.isActive;
        dataInput["type"] = true;
        this.setState(
          {
            ...this.state,
            id: row.id,
          },
          () => {
            //this.getDetailQualify();
            this.setState({ qualifyModalShow: true });
          }
        );
      },
    };
    const products = [];
    if (
      this.props.qualify.content &&
      this.props.qualify.content.items.length > 0
    ) {
      this.props.qualify.content.items.map((item, index) => {
        products.push(item);
      });
    }
    return (
      <div class="layout-container pd15 weblinkl">
        {/**Row 1 */}
        <div class="row no-gutters vertical-center h-50-px clTitle bg-white mg-botton">
          Công Ty Được Hành Nghề PCCC
        </div>
        <div class="row no-gutters vertical-center bg-white mg-botton2 p-2">
          <div className="col-12">
            <BootstrapTable
              rowEvents={rowEvents}
              keyField="id"
              data={products}
              columns={columns}
              pagination={pagination}
              classes="table-striped"
              rowClasses="mytable-hover-row"
            />
          </div>
          <div class="row no-gutters vertical-center">
            <div class="col d-flex justify-content-center">
              <button
                class="btn btn-primary"
                name="createModal"
                type="button"
                onClick={() => {
                  this.handleShowModal();
                }}
              >
                Tạo Mới
              </button>
            </div>
          </div>
        </div>
        <QualifyModal
          data={{
            show: this.state.qualifyModalShow,
            handleCloseModal: this.handleCloseModal,
            dataInput: dataInput,
          }}
        ></QualifyModal>
        <DeleteDialog
          isOpen={this.state.isOpenDelModal}
          onClose={() => {
            this.setState({ ...this.state, isOpenDelModal: false });
          }}
          onSuccess={() => {
            this.handleDelete();
            this.setState({ ...this.state, isOpenDelModal: false });
          }}
        ></DeleteDialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  qualify: state.qualify,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getQualify: qualifyAction.getQualify,
      deleteQualify: qualifyAction.deleteQualify,
      createQualify: qualifyAction.createQualify,
      updQualify: qualifyAction.updQualify,
      getLookupDistrict: lookupDistrictAction.getLookupDistrict,
      getLookupProvince: lookupProvinceAction.getLookupProvince,
      ShowLoading: ShowLoading,
      HiddenLoading: HiddenLoading,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(Qualify);
